import { CustomRouteObject } from '../../types/routes/Route.type';
import MainLayout from '../../layouts/MainLayout';
import AdminDashboard from '../../pages/AdminDashboard';
import AdminMonitorDashboard from '../../pages/AdminMonitorDashboard';
import AdminStrategyPage from '../../pages/AdminStrategyPage';
import InquiryPage from '../../pages/InquiryPage';
import BotSurveyCreatePage from '../../pages/BotSurveyCreatePage';
import ProtectedAdminRoute from '../../components/ProtectedAdminRoute';

const admin: CustomRouteObject = {
  id: 'adminRoot',
  path: '/admin',
  element: <MainLayout />,
  children: [
    {
      id: 'adminDashboard',
      path: 'dashboard',
      element: (
        <ProtectedAdminRoute>
          <AdminDashboard />
        </ProtectedAdminRoute>
      ),
    },
    {
      id: 'adminMonitor',
      path: 'monitor',
      element: (
        <ProtectedAdminRoute>
          <AdminMonitorDashboard />
        </ProtectedAdminRoute>
      ),
    },
    {
      id: 'adminStrategy',
      path: 'strategy',
      element: (
        <ProtectedAdminRoute>
          <AdminStrategyPage />
        </ProtectedAdminRoute>
      ),
    },
    {
      id: 'inquiry',
      path: 'inquiry',
      element: (
        <ProtectedAdminRoute>
          <InquiryPage />
        </ProtectedAdminRoute>
      ),
    },
    {
      id: 'botSurveyCreate',
      path: 'bot-survey-create',
      element: (
        <ProtectedAdminRoute>
          <BotSurveyCreatePage />
        </ProtectedAdminRoute>
      ),
    },
  ],
};

export default admin;
